import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { SITE_URL } from '@/utils/schema'

interface PageSeoProps {
  title: string
  description: string
  path: string
  schemas?: object[]
}

export default function PageSeo({ title, description, path, schemas = [] }: PageSeoProps) {
  const { i18n } = useTranslation()

  useEffect(() => {
    const meta = document.querySelector('meta[name="description"]')
    const canonical = document.querySelector('link[rel="canonical"]')
    const ogTitle = document.querySelector('meta[property="og:title"]')
    const ogDesc = document.querySelector('meta[property="og:description"]')
    const ogUrl = document.querySelector('meta[property="og:url"]')

    const prev = {
      title: document.title,
      desc: meta?.getAttribute('content') ?? '',
      canonical: canonical?.getAttribute('href') ?? '',
      ogTitle: ogTitle?.getAttribute('content') ?? '',
      ogDesc: ogDesc?.getAttribute('content') ?? '',
      ogUrl: ogUrl?.getAttribute('content') ?? '',
    }

    const absolute = `${SITE_URL}${path}`

    document.title = title
    if (meta) meta.setAttribute('content', description)
    if (canonical) canonical.setAttribute('href', absolute)
    if (ogTitle) ogTitle.setAttribute('content', title)
    if (ogDesc) ogDesc.setAttribute('content', description)
    if (ogUrl) ogUrl.setAttribute('content', absolute)

    return () => {
      document.title = prev.title
      if (meta) meta.setAttribute('content', prev.desc)
      if (canonical) canonical.setAttribute('href', prev.canonical)
      if (ogTitle) ogTitle.setAttribute('content', prev.ogTitle)
      if (ogDesc) ogDesc.setAttribute('content', prev.ogDesc)
      if (ogUrl) ogUrl.setAttribute('content', prev.ogUrl)
    }
  }, [title, description, path, i18n.language])

  return (
    <>
      {schemas.map((schema, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      ))}
    </>
  )
}